<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAttributes } from 'svelte/elements'
	import { cn } from 'tailwind-variants'

	let {
		ref = $bindable(null),
		class: className,
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLElement>> = $props()
</script>

<kbd
	bind:this={ref}
	class={cn('inline-flex items-center gap-1', className)}
	data-slot="kbd-group"
	{...restProps}
>
	{@render children?.()}
</kbd>
